(function ($) {
  const toggle = function () {
    const postamble = $(
      "div[data-question^='customer_telephone_number'] ~ .postamble",
    );
    const title = $("input[id^='customer_first_name']")
      .parents(".inner-box")
      .find("h2");
    const buyerSectionTitle = $("#buyer_first_name")
      .parents(".inner-box")
      .find("h2");
    const span = $("[id^='email_marketing_consent'] span.checkbox-label");
    const section = $("input[id^='customer_first_name']").parents(
      ".form-section",
    );

    const businessOwnerNoButton = $("#business_owner_no");

    const usaQuestionnaire = $("body").hasClass("usa");

    const inlandMarineQuestionnaire = $("body").hasClass("inland_marine");

    const businessOwnersPolicyQuestionnaire = $("body").hasClass("business_owners_policy");

    if (
      businessOwnerNoButton.length > 0 &&
      businessOwnerNoButton.is(":visible")
    ) {
      const isChecked = businessOwnerNoButton.is(":checked");
      if (usaQuestionnaire || inlandMarineQuestionnaire || businessOwnersPolicyQuestionnaire) {
        if (isChecked) {
          title.text("Policyholder information");
          span.text(
            span
              .text()
              .replace("Keep me", "Keep the policyholder")
              .replace("I understand I", "The policyholder understands they"),
          );
          buyerSectionTitle.text("Your information");
          section.css("margin-top", "48px");
          postamble.hide();
          title.show();
        } else {
          span.text(
            span
              .text()
              .replace("Keep the policyholder", "Keep me")
              .replace("The policyholder understands they", "I understand I"),
          );
          // this is to remove padding from the top of the section
          section.css("margin-top", "0px");
          postamble.show();
          title.hide();
        }
      } else if (isChecked) {
        postamble.hide();
        span.text(
          span
            .text()
            .replace("Keep me", "Keep the policyholder")
            .replace("I understand I", "The policyholder understands they"),
        );
        title.text("Policyholder contact details");
      } else {
        postamble.show();
        span.text(
          span
            .text()
            .replace("Keep the policyholder", "Keep me")
            .replace("The policyholder understands they", "I understand I"),
        );
        title.text("Please enter your contact details");
      }
    }
  };

  const toggleConsentWording = function () {
    if (!$("div[data-question='buyer_authority_confirmation']").length) return;

    const label = $("#sms_consent_control_label");
    label.text(
      label
        .text()
        .replace(
          "By checking below, you consent to receive",
          "By checking the below, you confirm you are authorized to, and consent to, the business owner receiving",
        ),
    );
  };

  if ($("body[data-journey-name='usa']").length) {
    toggle();
    toggleConsentWording();
    $("#business_owner_yes").click(toggle);
    $("#business_owner_no").click(toggle);
  }
})(window.jQuery);
